import styled from 'styled-components'

// Icons
import { ReactComponent as LockIcon } from 'icons/lock-16.svg'

// Local Components
import StripeField from '../StripeField'

export const InlineStripeField = styled(StripeField)`
  flex: 1;

  & + & {
    margin-left: ${({ theme }) => theme.space[5]}px;
  }
`

export const TransactionsText = styled.span`
  display: flex;
  align-items: center;

  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.colors.text.dark.secondary};

  user-select: none;
`

export const TransactionsIcon = styled(LockIcon)`
  margin-right: ${({ theme }) => theme.space[2]}px;
  color: ${({ theme }) => theme.colors.gray};

  width: 16px;
  height: 16px;
`

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
`

export const Section = styled.div`
  padding: ${({ theme }) => theme.space[8]}px 0;
`
